<div class="warning-container">
  <div class="flex grid-gap-10">
    <div class="flex-shrink-1 warning-icon">
      <i class="fa fa-warning" style="color: #f97316"></i>
    </div>
    <div class="flex-grow-1">
      <div class="warning-title">Account Paused</div>
      <div class="warning-text">
        You can continue to complete your current tasks, but please note that new jobs are
        temporarily unavailable.
      </div>
    </div>
  </div>
</div>
